/* eslint-disable no-new */
import * as utilReportPurchase from '@/api/reportPurchase'

const actions = {
  listPerSupplier({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      utilReportPurchase.listPerSupplier(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  totalTrxPerSupplier({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      utilReportPurchase.totalTrxPerSupplier(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  listPerProduct({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      utilReportPurchase.listPerProduct(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  totalTrxPerProduct({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      utilReportPurchase.totalTrxPerProduct(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  listPerTagihan({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      utilReportPurchase.listPerTagihan(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  totalTrxPerTagihan({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      utilReportPurchase.totalTrxPerTagihan(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  listPerUmurPiutang({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      utilReportPurchase.listPerUmurPiutang(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  totalTrxPerUmurPiutang({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      utilReportPurchase.totalTrxPerUmurPiutang(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  listPerHutang({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      utilReportPurchase.listPerHutang(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }

}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/reportPurchase.js